import { useEffect, useRef } from "react";

const CSS = "https://geowidget.inpost.pl/inpost-geowidget.css";
const JS = "https://geowidget.inpost.pl/inpost-geowidget.js";

function ensureAssets() {
  if (!document.querySelector(`link[href="${CSS}"]`)) {
    const l = document.createElement("link");
    l.rel = "stylesheet"; l.href = CSS;
    document.head.appendChild(l);
  }
  if (!document.querySelector(`script[src="${JS}"]`)) {
    const s = document.createElement("script");
    s.src = JS; s.defer = true;
    document.head.appendChild(s);
  }
}

export default function InpostGeowidget({ token, onSelect }) {
  const ref = useRef(null);
  useEffect(() => { ensureAssets(); }, []);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const handler = (e) => {
      const d = e.detail || {};
      const a = d.address || {};
      const addr = [a.line1, a.line2].filter(Boolean).join(", ");
      onSelect({ code: d.name || "", address: addr });
    };
    el.addEventListener("onpoint", handler);
    return () => el.removeEventListener("onpoint", handler);
  }, [onSelect]);
  return (
    <inpost-geowidget
      ref={ref}
      token={token}
      language="pl"
      config="parcelcollect"
      data-testid="inpost-geowidget"
      style={{ display: "block", width: "100%", height: "480px", borderRadius: "12px", overflow: "hidden" }}
    />
  );
}
